import { createStore, withProps } from '@ngneat/elf';
import { FundingDtoError, PaaMilestone, PaaMilestoneDto, RefParams, SlotDtoError } from '@/types';
import { SelectOption } from '@/components/form-builder/form-builder.types';
import { refParamsInitialState } from '@/store/ref-param-state/ref-param-state.store';
import { addMonths } from 'date-fns';

export interface PaaMilestoneProps {
  milestone: PaaMilestone;
  milestoneDto: PaaMilestoneDto;
  initialMilestoneDto: PaaMilestoneDto;
  serviceIdSelected: SelectOption;
  typeOfMarketIdSelected: SelectOption;
  selectionModeIdSelected: SelectOption;
  imputationBudgetaireIdSelected: SelectOption;
  errors?: Record<string, string[]>;
  slotErrors?: SlotDtoError[];
  fundingErrors?: FundingDtoError[];
}

export const initialMilestoneDto: PaaMilestoneDto = {
  id: 0,
  realisationEnvisagees: '',
  'service.id': undefined,
  beneficiaire: undefined,
  'typeMarcher.id': undefined,
  'modePassation.id': undefined,
  'imputationBudgetaire.id': undefined,
  budgetEstime: undefined,
  datePrevLps: new Date(),
  datePrevAc: addMonths(new Date(), 1),
  lots: [],
  financements: [],
  realisationFiles: [],
  docIds: [],
};

export const paaMilestonesInitialState: PaaMilestoneProps = {
  milestone: {
    id: 0,
    version: 0,
    realisationEnvisagees: '',
    beneficiaire: '',
    service: structuredClone(refParamsInitialState.response) as RefParams,
    typeMarcher: structuredClone(refParamsInitialState.response) as RefParams,
    modePassation: structuredClone(refParamsInitialState.response) as RefParams,
    imputationBudgetaire: structuredClone(refParamsInitialState.response) as RefParams,
    budgetEstime: undefined,
    datePrevLps: new Date().toISOString(),
    datePrevAc: new Date().toISOString(),
    isPublished: false,
    publishedAt: new Date().toISOString(),
    lots: [],
    financements: [],
    docs: [],
  },
  milestoneDto: structuredClone(initialMilestoneDto),
  initialMilestoneDto: structuredClone(initialMilestoneDto),
  serviceIdSelected: { name: '', code: 0 },
  typeOfMarketIdSelected: { name: '', code: 0 },
  selectionModeIdSelected: { name: '', code: 0 },
  imputationBudgetaireIdSelected: { name: '', code: 0 },
  slotErrors: [],
  fundingErrors: [],
};

export const paaMilestonesStoreFactory = (id: string) => {
  return createStore({ name: `paa-milestones-${id}` }, withProps<PaaMilestoneProps>(structuredClone(paaMilestonesInitialState)));
};
